import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import type { ITypeWizardStepperProps } from '@/@types/insuranceBuilder';

export function TypeWizardStepper({ steps, currentIndex }: ITypeWizardStepperProps) {
  return (
    <ol role="list" aria-label="Wizard steps" className="flex items-center gap-3 text-sm">
      {steps.map((step, idx) => {
        const isDone = idx < currentIndex;
        const isActive = idx === currentIndex;
        return (
          <li
            key={step.key}
            className="flex items-center gap-3"
            aria-current={isActive ? 'step' : undefined}
          >
            <span
              className={cn(
                'inline-flex h-6 w-6 items-center justify-center rounded-full border text-xs font-semibold',
                isDone && 'bg-primary text-primary-foreground border-primary',
                isActive && 'bg-primary/15 text-primary border-primary',
                !isDone && !isActive && 'bg-muted text-muted-foreground border-border'
              )}
              aria-hidden="true"
            >
              {isDone ? <Check className="h-3.5 w-3.5" aria-hidden="true" /> : idx + 1}
            </span>
            <span
              className={cn(
                'whitespace-nowrap',
                isActive && 'font-medium text-foreground',
                isDone && 'text-foreground',
                !isDone && !isActive && 'text-muted-foreground'
              )}
            >
              {step.label}
            </span>
            {idx < steps.length - 1 && (
              <span
                aria-hidden="true"
                className={cn('mx-2 h-px w-8', isDone ? 'bg-primary' : 'bg-border')}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
